import type { HotelsSuplierFieldResponseValidated } from '@lt/api/dist/methods/hotels/types';
import type { DOC_TYPE } from '@lt/api/dist/types/tourists';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState: HotelsSuplierFieldResponseValidated[] = [];

const supplierFieldsSlice = createSlice({
  name: 'supplierFields',
  initialState,
  reducers: {
    setSupplierFieldsData: (
      _: HotelsSuplierFieldResponseValidated[],
      action: PayloadAction<HotelsSuplierFieldResponseValidated[]>,
    ) => action.payload,
  },
});

export const { setSupplierFieldsData } = supplierFieldsSlice.actions;

export const updateSupplierFields = createAction<{
  index: number;
  docType: DOC_TYPE;
}>('supplierFields/updateTouristField');

export const downloadSupplierFields = createAction(
  'supplierFields/downloadSupplierFields',
);

const { name, reducer } = supplierFieldsSlice;
export { reducer as default, name };
